import React, { useEffect, useState } from 'react';
import { RadioButtonList } from 'components/radio-button/list';

const AddChargeAgain = (props: any) => {
    const [ignoreOnRefresh, setIgnoreOnRefresh] = useState<string>('');

    useEffect(() => {
        if (props.show) {
            handleChange('Y');
        }
    }, [props.show]);

    const handleChange = (e: any) => {
        setIgnoreOnRefresh(e);
        if (props.onIgnoreOnRefreshChange) {
            props.onIgnoreOnRefreshChange(e);
        }
    };

    return (
        <>
            <RadioButtonList
                className={'col-50 padding-top-small'}
                label="Add charge again upon rate refresh?"
                value={ignoreOnRefresh}
                hasError={props.required && !ignoreOnRefresh}
                error={'This field is required'}
                list={[{
                    label: 'Yes (Charge will be added again)',
                    name: 'dontAddChargeAgain',
                    value: 'N'
                }, {
                    label: 'No (Charge will not be added again)',
                    name: 'dontAddChargeAgain',
                    value: 'Y'
                }]}
                onChange={handleChange}
            />
        </>
    );
};

export default AddChargeAgain;